export default "__VITE_ASSET__7467294a__"